export const telephone = '02171148100'
export const email = 'info@tebinja.com'